import startCase from 'lodash/startCase';
import { ApiAdapter } from '@unmapped/core/state';
import { ENDPOINT_CEMETERIES } from '../../../apiConfig';
export const CemeteryAdapter = new ApiAdapter();
CemeteryAdapter.resolveResults('results').handleRequest(async h => {
  const res = await fetch(ENDPOINT_CEMETERIES || '/api/cemeteries');
  const json = await res.json();
  return json;
}).location.resolveId('id').resolveName('name').resolve('__kind', () => 'cemetery').resolve('operator', result => result.nondiocesan ? 'other' : 'diocese').resolveLatLng({
  lat: 'location.lat',
  lng: 'location.lng'
}).resolve('displayAddress', result => [startCase(result.location.address), result.location.address2 ? startCase(result.location.address2) : undefined, `${startCase(result.location.city)}, ${result.location.state} ${result.location.zip}`].filter(line => !!line));
export default CemeteryAdapter;